<script>
  import { format } from 'svelte-i18n';
  import { Modal, ModalBody } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { IMAGE_UPLOAD_TYPES } from '@client/enums';

  export let choice = '';
  export let show = false;
  export let showNextModal = false;

  const onClick = (uploadOption) => {
    choice = uploadOption;

    show = false;
    setTimeout(() => (showNextModal = true), 200);

    return choice;
  };

  const onKeyUp = (event) => {
    if (event.key === 'Escape') {
      show = false;
    }
  };
</script>

<Modal bind:isOpen={show} close={false} size="lg" fullscreen="lg">
  <ModalBody class="image-upload-option-modal">
    <button class="close" on:click={() => (show = !show)}>
      <Icon name="x" />
    </button>
    <div>
      <h1>{$format('label.IMAGE_MODAL_NEW_IMAGE')}</h1>
      <p>{$format('label.DESCRIPTION.IMAGE_MODAL_NEW_IMAGE')}</p>
    </div>
    <div class="options">
      <button on:click={() => onClick(IMAGE_UPLOAD_TYPES.single.id)}>
        <div>
          <Icon name="image" />
          <b>{$format(IMAGE_UPLOAD_TYPES.single.label)}</b>
        </div>
        <p>{$format('label.DESCRIPTION.IMAGE_MODAL_SINGLE_UPLOAD')}</p>
      </button>
      <button on:click={() => onClick(IMAGE_UPLOAD_TYPES.bulk.id)}>
        <div>
          <Icon name="image" />
          <b>{$format(IMAGE_UPLOAD_TYPES.bulk.label)}</b>
        </div>
        <p>{$format('label.DESCRIPTION.IMAGE_MODAL_BULK_UPLOAD')}</p>
      </button>
    </div>
  </ModalBody>
</Modal>

<svelte:window on:keyup={onKeyUp} />

<style lang="scss" src="./image-choice-modal.scss"></style>
